import React from 'react'
import { Button } from "semantic-ui-react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import MARVEL from "../../common/utils/MarvelUrls";

export class VeritasSidebarButtons extends React.Component {
    render() {
        return (
            <div>
                <Button.Group vertical>
                    <Link to={MARVEL.VERITAS.home}>
                        <Button
                            className="sidebar-buttons"
                            icon="home"
                            content=" Veritas"
                        />
                    </Link>

                    <Link to={MARVEL.VERITAS.kyc}>
                        <Button
                            className="sidebar-buttons"
                            icon="id card outline"
                            content=" KYC Services"
                        />
                    </Link>

                    <Link to={MARVEL.VERITAS.kyb}>
                        <Button
                            className="sidebar-buttons"
                            icon="building outline"
                            content=" KYB Services"
                        />
                    </Link>

                    <Link to={MARVEL.VERITAS.data_providers}>
                        <Button
                            className="sidebar-buttons"
                            icon="database"
                            content=" Data Providers"
                        />
                    </Link>

                    {this.props.isAdmin || this.props.isSupervisor || this.props.isDPAdmin || this.props.isDPEditor
                        ? (
                            <Link to={MARVEL.VERITAS.billing_groups}>
                                <Button
                                    className="sidebar-buttons"
                                    icon="dollar"
                                    content=" Billing Groups"
                                />
                            </Link>
                        )
                        : null}

                    <Link to={MARVEL.VERITAS.country_coverage}>
                        <Button
                            className="sidebar-buttons"
                            icon="world"
                            content=" Country Coverage"
                        />
                    </Link>
                </Button.Group>
            </div >
        );
    }
}

const mapStateToProps = (state) => ({
    isAdmin: state.marvel.user.access.accessLevel.isAdmin,
    isSupervisor: state.marvel.user.access.accessLevel.isSupervisor,
    isDPAdmin: state.marvel.user.access.accessLevel.isDPAdmin,
    isDPEditor: state.marvel.user.access.accessLevel.isDPEditor,
})

const mapDispatchToProps = (state) => ({})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(VeritasSidebarButtons);
